export const config_2000 = {
    SCOTTISH: false,
    MIN_SALARY: 1,
    MAX_SALARY: 200000,
    DEFAULT_SALARY: 100000,
    PERSONAL_ALLOWANCE: 12570,
    PERSONAL_ALLOWANCE_THRESHOLD: 100000,
    TAX_BANDS: [
      { threshold: 12570, rate: 0, min: 0, max: 12570, breadth: 12570 },
      { threshold: 50270, rate: 10, min: 12570, max: 50270, breadth: 37700 },
      { threshold: 125140, rate: 10, min: 50270, max: 125140, breadth: 74870 },
      { threshold: Infinity, rate: 15, min: 125140, max: Infinity, breadth: Infinity },
    ],
    // These are used if full personal allowance is lost
    ADJUSTED_TAX_BANDS: [
      { breadth: 37700, rate: 10 },
      { breadth: 74870, rate: 10 },
      { breadth: Infinity, rate: 15 }
    ],
    STUDENT_LOANS: {
      plan1: { threshold: 24990, rate: 9 },
      plan2: { threshold: 27295, rate: 9 },
      plan4: { threshold: 31395, rate: 9 },
      postgraduate: { threshold: 21000, rate: 6 },
    },
    NI: {
      LOWER_THRESHOLD: 1048 * 12,
      UPPER_THRESHOLD: 4189 * 12,
      MIDDLE_RATE: 0.08,
      UPPER_RATE: 0.02,
    },
    PENSIONS: {
      QUALIFYING_EARNINGS: {
        LOWER_THRESHOLD: 6240,
        UPPER_THRESHOLD: 50270,
      },
      SCHEMES: {
        "Auto-enrolment": {
          inputType: "percentage",          // User inputs a percentage
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,         // Deducted at source
        },
        "Employer/Occupational": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Salary Sacrifice": {
          // Salary Sacrifice can be based on Gross Salary or Qualifying Earnings.
          // The calculationBasis can be chosen by the user.
          inputType: "percentage",
          // We'll let the user decide the basis at runtime.
          deductFromTakeHome: true,
        },
        "Personal": {
          inputType: "percentage",
          // Typically users may choose Gross Salary or Qualifying Earnings.
          // However, the key distinction is that personal contributions are not deducted from take-home pay.
          deductFromTakeHome: false,
        },
      },
    },
  };
  
  export const config_2024 = {
    SCOTTISH: false,
    MIN_SALARY: 1,
    MAX_SALARY: 200000,
    DEFAULT_SALARY: 100000,
    PERSONAL_ALLOWANCE: 12570,
    PERSONAL_ALLOWANCE_THRESHOLD: 100000,
    TAX_BANDS: [
      { threshold: 12570, rate: 0, min: 0, max: 12570, breadth: 12570 },
      { threshold: 50270, rate: 20, min: 12570, max: 50270, breadth: 37700 },
      { threshold: 125140, rate: 40, min: 50270, max: 125140, breadth: 74870 },
      { threshold: Infinity, rate: 45, min: 125140, max: Infinity, breadth: Infinity },
    ],
    // These are used if full personal allowance is lost
    ADJUSTED_TAX_BANDS: [
      { breadth: 37700, rate: 20 },
      { breadth: 87440, rate: 40 },
      { breadth: Infinity, rate: 45 }
    ],
    STUDENT_LOANS: {
      plan1: { threshold: 24990, rate: 9 },
      plan2: { threshold: 27295, rate: 9 },
      plan4: { threshold: 31395, rate: 9 },
      postgraduate: { threshold: 21000, rate: 6 },
    },
    NI: {
      LOWER_THRESHOLD: 1048 * 12,
      UPPER_THRESHOLD: 4189 * 12,
      MIDDLE_RATE: 0.08,
      UPPER_RATE: 0.02,
    },
    PENSIONS: {
      QUALIFYING_EARNINGS: {
        LOWER_THRESHOLD: 6240,
        UPPER_THRESHOLD: 50270,
      },
      SCHEMES: {
        "Auto-enrolment": {
          inputType: "percentage",          // User inputs a percentage
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,         // Deducted at source
        },
        "Employer/Occupational": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Salary Sacrifice": {
          // Salary Sacrifice can be based on Gross Salary or Qualifying Earnings.
          // The calculationBasis can be chosen by the user.
          inputType: "percentage",
          // We'll let the user decide the basis at runtime.
          deductFromTakeHome: true,
        },
        "Personal": {
          inputType: "percentage",
          // Typically users may choose Gross Salary or Qualifying Earnings.
          // However, the key distinction is that personal contributions are not deducted from take-home pay.
          deductFromTakeHome: false,
        },
      },
    },
  };
  
  export const config_2024_scottish = {
    SCOTTISH: true,
    MIN_SALARY: 1,
    MAX_SALARY: 200000,
    DEFAULT_SALARY: 100000,
    PERSONAL_ALLOWANCE: 12570,
    PERSONAL_ALLOWANCE_THRESHOLD: 100000,
    TAX_BANDS: [
      { threshold: 12570, rate: 0, min: 0, max: 12570, breadth: 12570 },
      { threshold: 14876, rate: 19, min: 12571, max: 14876, breadth: 2305 },
      { threshold: 26561, rate: 20, min: 14877, max: 26561, breadth: 11684 },
      { threshold: 43662, rate: 21, min: 26562, max: 43662, breadth: 17100 },
      { threshold: 75000, rate: 42, min: 43663, max: 75000, breadth: 31337 },
      { threshold: 125140, rate: 45, min: 75001, max: 125140, breadth: 50139 },
      { threshold: Infinity, rate: 48, min: 125141, max: Infinity, breadth: Infinity },
    ],
    // Adjusted tax bands for when full personal allowance is lost.
    ADJUSTED_TAX_BANDS: [
      { breadth: 2305, rate: 19 },
      { breadth: 11684, rate: 20 },
      { breadth: 17100, rate: 21 },
      { breadth: 31337, rate: 42 },
      { breadth: 50139, rate: 45 },
      { breadth: Infinity, rate: 48 },
    ],
    STUDENT_LOANS: {
      plan1: { threshold: 24990, rate: 9 },
      plan2: { threshold: 27295, rate: 9 },
      plan4: { threshold: 31395, rate: 9 },
      postgraduate: { threshold: 21000, rate: 6 },
    },
    NI: {
      LOWER_THRESHOLD: 1048 * 12,
      UPPER_THRESHOLD: 4189 * 12,
      MIDDLE_RATE: 0.08,
      UPPER_RATE: 0.02,
    },
    PENSIONS: {
      QUALIFYING_EARNINGS: {
        LOWER_THRESHOLD: 6240,
        UPPER_THRESHOLD: 50270,
      },
      SCHEMES: {
        "Auto-enrolment": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Employer/Occupational": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Salary Sacrifice": {
          inputType: "percentage",
          deductFromTakeHome: true,
        },
        "Personal": {
          inputType: "percentage",
          deductFromTakeHome: false,
        },
      },
    },
  };
  
  export const config_2025 = {
    SCOTTISH: false,
    MIN_SALARY: 1,
    MAX_SALARY: 200000,
    DEFAULT_SALARY: 100000,
    PERSONAL_ALLOWANCE: 12570, // Frozen until 2028
    PERSONAL_ALLOWANCE_THRESHOLD: 100000,
    TAX_BANDS: [
      { threshold: 12570, rate: 0, min: 0, max: 12570, breadth: 12570 },
      { threshold: 50270, rate: 20, min: 12570, max: 50270, breadth: 37700 },
      { threshold: 125140, rate: 40, min: 50270, max: 125140, breadth: 74870 },
      { threshold: Infinity, rate: 45, min: 125140, max: Infinity, breadth: Infinity },
    ],
    // These are used if full personal allowance is lost
    ADJUSTED_TAX_BANDS: [
      { breadth: 37700, rate: 20 },
      { breadth: 87440, rate: 40 },
      { breadth: Infinity, rate: 45 }
    ],
    STUDENT_LOANS: {
      plan1: { threshold: 24990, rate: 9 },
      plan2: { threshold: 27295, rate: 9 },
      plan4: { threshold: 31395, rate: 9 },
      postgraduate: { threshold: 21000, rate: 6 },
    },
    NI: {
      LOWER_THRESHOLD: 1048 * 12, // £12,576 annually
      UPPER_THRESHOLD: 4189 * 12, // £50,268 annually
      MIDDLE_RATE: 0.08, // 8% between lower and upper threshold
      UPPER_RATE: 0.02, // 2% above upper threshold
    },
    PENSIONS: {
      QUALIFYING_EARNINGS: {
        LOWER_THRESHOLD: 6240,
        UPPER_THRESHOLD: 50270,
      },
      // 2029 rule: Salary sacrifice contributions above this threshold become subject to NI
      NI_SALARY_SACRIFICE_THRESHOLD: 2000,
      SCHEMES: {
        "Auto-enrolment": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Employer/Occupational": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Salary Sacrifice": {
          inputType: "percentage",
          deductFromTakeHome: true,
        },
        "Personal": {
          inputType: "percentage",
          deductFromTakeHome: false,
        },
      },
    },
  };

  export const config_2025_scottish = {
    SCOTTISH: true,
    MIN_SALARY: 1,
    MAX_SALARY: 200000,
    DEFAULT_SALARY: 100000,
    PERSONAL_ALLOWANCE: 12570,
    PERSONAL_ALLOWANCE_THRESHOLD: 100000,
    TAX_BANDS: [
      { threshold: 12570, rate: 0, min: 0, max: 12570, breadth: 12570 },
      { threshold: 14876, rate: 19, min: 12571, max: 14876, breadth: 2305 },
      { threshold: 26561, rate: 20, min: 14877, max: 26561, breadth: 11684 },
      { threshold: 43662, rate: 21, min: 26562, max: 43662, breadth: 17100 },
      { threshold: 75000, rate: 42, min: 43663, max: 75000, breadth: 31337 },
      { threshold: 125140, rate: 45, min: 75001, max: 125140, breadth: 50139 },
      { threshold: Infinity, rate: 48, min: 125141, max: Infinity, breadth: Infinity },
    ],
    ADJUSTED_TAX_BANDS: [
      { breadth: 2305, rate: 19 },
      { breadth: 11684, rate: 20 },
      { breadth: 17100, rate: 21 },
      { breadth: 31337, rate: 42 },
      { breadth: 50139, rate: 45 },
      { breadth: Infinity, rate: 48 }
    ],
    STUDENT_LOANS: {
      plan1: { threshold: 24990, rate: 9 },
      plan2: { threshold: 27295, rate: 9 },
      plan4: { threshold: 31395, rate: 9 },
      postgraduate: { threshold: 21000, rate: 6 },
    },
    NI: {
      LOWER_THRESHOLD: 1048 * 12,
      UPPER_THRESHOLD: 4189 * 12,
      MIDDLE_RATE: 0.08,
      UPPER_RATE: 0.02,
    },
    PENSIONS: {
      QUALIFYING_EARNINGS: {
        LOWER_THRESHOLD: 6240,
        UPPER_THRESHOLD: 50270,
      },
      // 2029 rule: Salary sacrifice contributions above this threshold become subject to NI
      NI_SALARY_SACRIFICE_THRESHOLD: 2000,
      SCHEMES: {
        "Auto-enrolment": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Employer/Occupational": {
          inputType: "percentage",
          calculationBasis: "Qualifying Earnings",
          deductFromTakeHome: true,
        },
        "Salary Sacrifice": {
          inputType: "percentage",
          deductFromTakeHome: true,
        },
        "Personal": {
          inputType: "percentage",
          deductFromTakeHome: false,
        },
      },
    },
  };

  // Export a map of all available configurations
  export const CONFIGURATIONS = {
    '2000': config_2000,
    '2024': config_2024,
    '2024_scottish': config_2024_scottish,
    '2025': config_2025,
    '2025_scottish': config_2025_scottish,
  };
  